module.exports = __webpack_public_path__ + "static/media/uoc.47e59c27.png";